import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RegisterService } from '../register.service';
import { AlertService } from '@kodit/core/services';

@Component({
  selector: 'kodit-step-1',
  templateUrl: './step1.component.html',
  styleUrls: ['./step1.component.scss'],
})
export class Step1Component implements OnInit {
  constructor(
    private _router: Router,
    private _alertService: AlertService,
    private _registerService: RegisterService
  ) {}

  ngOnInit(): void {}

  nextStep() {
    // Popuni pakete i dodatna polja

    if (
      this._registerService.getForm.value.odabirPaketaDto.packages.length === 0
    ) {
      this._alertService.addWarnMsg('Potrebno je odabrati bar jedan paket!');
      return;
    }

    // Navigacija na sleedeći korak
    this._router
      .navigate(['/autentikacija', 'registracija', 'podaci-kompanije'])
      .then();
  }
}
